import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const START_SCALE = 0.4; // scala iniziale dell'immagine (poi cresce a 1 su scroll)

// Zoom Scroll: la sezione resta pinnata mentre l'immagine zooma da START_SCALE a 1
// (copre tutto), legata allo scroll (scrub). A zoom concluso, sopra l'immagine
// compare il contenuto (scrim + intro + tappe) nella seconda meta' dello scroll.
// Pin/zoom SOLO da >=992px (lg): sotto, il contenuto non entra in 100vh, quindi la
// sezione prende altezza naturale e resta statica (gestito via gsap.matchMedia).
const zoomScroll = () => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll(".zoom-scroll").forEach((section) => {
    const media = section.querySelector(".zoom-scroll__media");
    if (!media || reduce) return;

    const scrim = section.querySelector(".zoom-scroll__scrim");
    const intro = section.querySelector(".zoom-scroll__intro");
    const steps = section.querySelectorAll(".zoom-scroll__step");
    const hasContent = Boolean(scrim || intro || steps.length);
    const animated = [media, scrim, intro, ...steps].filter(Boolean);

    const mm = gsap.matchMedia();

    // Solo desktop (>= lg): pin + zoom + reveal. matchMedia crea/distrugge al
    // superamento del breakpoint; il cleanup ripristina gli elementi (clearProps)
    // cosi' su mobile valgono gli stati visibili del CSS.
    mm.add("(min-width: 992px)", () => {
      let tl;
      let started = false;

      const setup = () => {
        if (started) return;
        started = true;

        tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top top",
            // Con contenuto: 1a meta' zoom, 2a meta' reveal. Senza: solo zoom.
            end: hasContent ? "+=200%" : "+=100%",
            scrub: true,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });

        // Fase 1 — zoom immagine (scale su tutta la fase; fade-in nella prima parte).
        tl.fromTo(media, { scale: START_SCALE }, { scale: 1, ease: "none", duration: 1 }, 0);
        tl.fromTo(media, { autoAlpha: 0 }, { autoAlpha: 1, ease: "none", duration: 0.35 }, 0);

        // Fase 2 — reveal contenuto a zoom concluso (pos 1 -> ~1.9 su durata 2).
        if (hasContent) {
          if (scrim) {
            tl.to(scrim, { autoAlpha: 1, ease: "none", duration: 0.4 }, 1);
          }
          if (intro) {
            tl.fromTo(
              intro,
              { autoAlpha: 0, y: 40 },
              { autoAlpha: 1, y: 0, ease: "power2.out", duration: 0.6 },
              1.1
            );
          }
          if (steps.length) {
            tl.fromTo(
              steps,
              { autoAlpha: 0, y: 40 },
              { autoAlpha: 1, y: 0, ease: "power2.out", duration: 0.6, stagger: 0.12 },
              1.25
            );
          }
        }

        ScrollTrigger.refresh();
      };

      // Come i reveal/entrate: se l'intro hero e' in corso, aspetta il pin (evento
      // hero-split:intro-done) per avere le posizioni corrette; altrimenti subito.
      if (document.documentElement.classList.contains("hero-split-intro")) {
        document.addEventListener("hero-split:intro-done", setup, { once: true });
      } else {
        setup();
      }

      // Cleanup uscendo dal desktop (resize < lg): rimuovi listener, uccidi la
      // timeline+ScrollTrigger (toglie il pin) e azzera gli stili inline residui.
      return () => {
        document.removeEventListener("hero-split:intro-done", setup);
        if (tl) {
          if (tl.scrollTrigger) tl.scrollTrigger.kill();
          tl.kill();
        }
        gsap.set(animated, { clearProps: "all" });
      };
    });
  });
};

export default zoomScroll;
